module.exports = __webpack_public_path__ + "img/zhuanzhou.prt.f97ac75b.jpg";